/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-review-response__textarea[_ngcontent-%COMP%]{width:100%}textarea[_ngcontent-%COMP%]{height:100px;border:1px solid #00a3e0;padding-top:0}"];
export { styles as styles };
